import { rootApi, prepareCommonHeaders } from './baseApi';
import { API_CONFIG } from '../config/api.config';

export interface BackfillStatus {
  sensor_id: string;
  total_entries: number;
  acknowledged: number;
  remaining: number;
  progress_percent: number;
  timeframe_days: number;
  timeframe_hours: number;
  created_at: string;
  updated_at: string;
  seconds_since_update: number;
}

export const backfillApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getBackfillStatus: builder.query<BackfillStatus[], void>({
      // Cache for 10 seconds since it's polled every 10 seconds
      keepUnusedDataFor: 10,
      queryFn: async () => {
        try {
          const response = await fetch(`${API_CONFIG.baseURL}/backfill-status`, {
            method: 'GET',
            credentials: 'include',
            headers: prepareCommonHeaders(),
          });

          if (!response.ok) {
            throw new Error('Failed to fetch backfill status');
          }

          const data = await response.json();
          
          if (!Array.isArray(data)) {
            console.warn('Invalid backfill status response:', data);
            return { data: [] };
          }

          return { data };
        } catch (error) {
          console.error('Error fetching backfill status:', error);
          return { error: 'Failed to fetch backfill status' };
        }
      },
      providesTags: ['BackfillStatus'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBackfillStatusQuery
} = backfillApi;
